import React, { useState, useContext, useEffect } from 'react'
import ProductFieldsView from '@/custom/components/organisms/Product/EditFieldsView'
import { dateTimeFormatFunction } from '@/product/common/components'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import * as Yup from 'yup'
import SettingContext from '@/product/context/setting/settingContext'
import Layout from '@/product/components/templates/Layout'
import { useHistory } from 'react-router-dom'
import CustomCommonContext from '@/custom/context/common/commonContext'
import commonContext from '@/product/context/common/commonContext'
import settingContext from '@/custom/context/setting/settingContext'
import AuthContext from '@/product/context/auth/authContext'
import UserContext from '@/product/context/user/userContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import AuctionContext from '@/product/context/auction/auctionContext'

const DynamicListing = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const [anotherArray, setAnotherArray] = useState([])
    const { project_dynamicfields } = dynamicContext
    const customCommonContext = useContext(CustomCommonContext)
    const { allCountries, allStates, allCities } =
        useContext(ProductCommonContext)
    const settingContexts = useContext(settingContext)
    const settingcontext = useContext(SettingContext)
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated } = authContext
    const auctionContext = useContext(AuctionContext)
    const { all_auctions, getAllAuctions } = auctionContext
    const [allautiondetails, setAllauctions] = useState([])
    const {
        all_users,
        getAllUsers,
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
    } = useContext(UserContext)

    const { getAllGlobalData, all_global_data } = settingContexts

    const history = useHistory()

    const [updatedValues, setUpdatedValues] = useState({})

    const [inisitalValue, setInisitialValue] = useState()

    const {
        alldata_all_dropdown,
        getGlobalVariable,
        allConfigurationVariables,
    } = customCommonContext
    const [data, setData] = useState({
        popup: false,
        status: 'new',
        id: 0,
        projectType: 0,
    })

    useEffect(() => {
        if (isAuthenticated) {
            getAllAuctions(
                {
                    page: 1,
                    limit: 50,
                    order: '',
                    orderby: '',
                    auctionTimeFilter: true,
                    filters: {
                        market_status: {
                            value: 'open',
                            type: 'in',
                            field: 'ac.market_status',
                        },
                    },
                },
                'assignAuctions'
            )
        }
    }, [isAuthenticated])
    useEffect(() => {
        const projectToShow = []
        if (all_auctions && all_auctions.records.length > 0) {
            projectToShow.push({
                id: 0,
                value: 0,
                show: 'Standard 72 Hour Auction',
            })

            all_auctions.records.map((lot) => {
                projectToShow.push({ value: lot.id, show: lot.title })
            })

            setAllauctions(projectToShow)
        } else {
            setAllauctions(projectToShow)
        }
    }, [all_auctions])

    useEffect(() => {
        getAllGlobalData()
        getAllUsers({
            filters: {
                action: {
                    value: 'active',
                    type: 'in',
                    field: 'u.status',
                },
                admin: {
                    value: '1',
                    type: 'in',
                    field: 'u.admin',
                },
            },
        })
    }, [])

    const {
        searchTableAction,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const optionFunc = (data) => {
        searchTableFetch(
            {
                page: 1,
                limit: 25,
                order: '',
                orderby: '',
                filters: {
                    user_id: {
                        value: data,
                        type: 'like',
                        field: 'e.emp_firstname,e.emp_lastname,e.username,e.id,e.emp_email',
                    },
                },
                primaryTable: 'employees',
            },
            'employees'
        )
    }
    const custom = {
        user_id: '',
        first_name: '',
        last_name: '',
        email: '',
        auction: 1,
    }

    useEffect(() => {
        if (props?.data && props?.data?.id) {
            setData((data) => {
                return {
                    ...data,
                    popup: props?.data?.popup,
                    status: props?.data?.status,
                    id: props?.data?.id ? props?.data?.id : 0,
                    projectType: 0,
                }
            })
        }
    }, [props?.data])

    useEffect(() => {
        if (alldata_all_dropdown) {
            let val = alldata_all_dropdown.filter(
                (item) => item.variable == 'listing_type'
            )
            setInisitialValue(val[0]?.id)
        }
    }, [alldata_all_dropdown])

    const [fieldValue, setFieldValue] = useState([])

    useEffect(() => {
        if (
            project_dynamicfields &&
            project_dynamicfields?.length !== fieldValue?.length &&
            all_global_data?.records?.length
        ) {
            let projectDynamicArray = [...project_dynamicfields]
            let dynamicValueAssign = []
            let projectType = ''
            projectDynamicArray
                .filter((data) => data.active === 1)
                .map((item) => {
                    if (item.view_on && projectType) {
                        if (
                            item.view_on.includes(projectType) ||
                            item.view_on.includes('10')
                        ) {
                            if (item.name === 'qty') {
                                item.initialDefault = 1
                            } else if (item.name === 'sprice') {
                                item.initialDefault = 1
                            } else if (item.type == 'uploadDropZone') {
                                item.isCrop = true
                                item.reorder = true
                            } else if (item.name == 'cigar_source') {
                                item.diff_value = 1
                                item.options =
                                    all_global_data?.cigar_source?.length > 0
                                        ? all_global_data.cigar_source?.map(
                                              (value) => ({
                                                  description:
                                                      value.source_value,
                                                  show: value.source_value,
                                                  value: value.source_value,
                                              })
                                          )
                                        : []
                            } else if (item.name == 'maker') {
                                if (all_global_data?.records.length > 0) {
                                    // Step 1: Extract unique makers using a Set to avoid duplicates
                                    const uniqueMakers = [
                                        ...new Set(
                                            all_global_data.records.map(
                                                (record) => record.Maker
                                            )
                                        ),
                                    ]

                                    // Step 2: Map each unique maker to the required structure
                                    item.options = uniqueMakers.map(
                                        (maker) => ({
                                            description: maker,
                                            show: maker,
                                            value: maker,
                                        })
                                    )

                                    // Step 3: Filter the unique makers for those that contain "Habanos" (case-insensitive)
                                    const filteredData = uniqueMakers.filter(
                                        (maker) => /Habanos/i.test(maker)
                                    )

                                    // Step 4: Set the initialDefault if there's a match in the filteredData
                                    if (filteredData.length > 0) {
                                        item.initialDefault = filteredData[0] // Take the first matching value
                                    }
                                }
                            } else if (item.name == 'maker_country') {
                                item.initialDefault = 'Cuba '
                            } else if (item.name == 'cigar_country') {
                                item.initialDefault = 'Cuba'
                            } else if (item.name == 'delivery_not_available') {
                                item.diff_value = 1
                                item.class = 'd-none'
                            } else if (
                                item.name == 'delivery_available_country'
                            ) {
                                item.diff_value = 1
                                item.class = 'd-none'
                                // let countrySelectedAll = allCountries.map(
                                //     (country) => country.isoCode
                                // )
                                // item.initialDefault = countrySelectedAll
                            } else if (item.name == 'source_location') {
                                item.options = allCountries
                                    .filter(
                                        (country) => country?.isoCode !== 'EU'
                                    ) // Assuming 'currency' field indicates EU
                                    .map((country) => ({
                                        show: country.name,
                                        value: country.isoCode,
                                    }))
                                item.country = false
                            } else if (item.name == 'storage_location') {
                                item.options = allCountries
                                    .filter(
                                        (country) => country?.isoCode !== 'EU'
                                    ) // Assuming 'currency' field indicates EU
                                    .map((country) => ({
                                        show: country.name,
                                        value: country.isoCode,
                                    }))
                                item.country = false
                            } else if (item.name == 'item') {
                                if (alldata_all_dropdown) {
                                    let val = alldata_all_dropdown.filter(
                                        (item) => item.variable == 'item'
                                    )

                                    item.initialDefault = val[0]?.id
                                }
                            } else if (item.name == 'user_id') {
                                item.type = 'searchdrop'
                                item.style = { height: 30 }
                                item.getAllOptions = optionFunc
                                item.options = []
                                item.forcePopupIcon = false
                                item.focused = true
                            } else if (item?.name == 'auctionid') {
                                item.options = allautiondetails
                                item.class =
                                    all_auctions?.records?.length > 0
                                        ? 'col-sm-12 col-12'
                                        : 'd-none'
                            }

                            dynamicValueAssign.push(item)
                        }
                    } else {
                        if (item.name === 'qty') {
                            item.initialDefault = 1
                        } else if (item.name === 'sprice') {
                            item.initialDefault = 1
                        } else if (item.type == 'uploadDropZone') {
                            item.isCrop = true
                        } else if (item.name == 'maker') {
                            if (all_global_data?.records.length > 0) {
                                // Step 1: Extract unique makers using a Set to avoid duplicates
                                const uniqueMakers = [
                                    ...new Set(
                                        all_global_data.records.map(
                                            (record) => record.Maker
                                        )
                                    ),
                                ]

                                // Step 2: Map each unique maker to the required structure
                                item.options = uniqueMakers.map((maker) => ({
                                    description: maker,
                                    show: maker,
                                    value: maker,
                                }))

                                // Step 3: Filter the unique makers for those that contain "Habanos" (case-insensitive)
                                const filteredData = uniqueMakers.filter(
                                    (maker) => /Habanos/i.test(maker)
                                )

                                // Step 4: Set the initialDefault if there's a match in the filteredData
                                if (filteredData.length > 0) {
                                    item.initialDefault = filteredData[0] // Take the first matching value
                                }
                            }
                        } else if (item.name == 'item') {
                            if (alldata_all_dropdown) {
                                let val = alldata_all_dropdown.filter(
                                    (item) => item.variable == 'item'
                                )

                                item.initialDefault = val[0]?.id
                            }
                        } else if (item.name == 'maker_country') {
                            item.initialDefault = 'Cuba'
                        } else if (item.name == 'cigar_country') {
                            item.initialDefault = 'Cuba'
                        } else if (item.name == 'cigar_source') {
                            item.diff_value = 1
                            item.options =
                                all_global_data?.cigar_source?.length > 0
                                    ? all_global_data.cigar_source?.map(
                                          (value) => ({
                                              description: value.source_value,
                                              show: value.source_value,
                                              value: value.source_value,
                                          })
                                      )
                                    : []
                        } else if (item.name == 'standard_delivery_included') {
                            if (alldata_all_dropdown) {
                                let val = alldata_all_dropdown.filter(
                                    (item) =>
                                        item.variable ==
                                            'standard_delivery_included' &&
                                        item.description == 'No'
                                )

                                item.initialDefault = val[0]?.id
                            }
                        } else if (item.name == 'source_location') {
                            item.options = allCountries
                                .filter((country) => country?.isoCode !== 'EU') // Assuming 'currency' field indicates EU
                                .map((country) => ({
                                    show: country.name,
                                    value: country.isoCode,
                                }))
                            item.country = false
                        } else if (item.name == 'storage_location') {
                            item.options = allCountries
                                .filter((country) => country?.isoCode !== 'EU') // Assuming 'currency' field indicates EU
                                .map((country) => ({
                                    show: country.name,
                                    value: country.isoCode,
                                }))
                            item.country = false
                        } else if (item.name == 'delivery_to') {
                            if (alldata_all_dropdown) {
                                let val = alldata_all_dropdown.filter(
                                    (item) =>
                                        item.variable == 'delivery_to' &&
                                        item.description == 'All'
                                )

                                item.initialDefault = val[0]?.id
                            }
                        } else if (item.name == 'delivery_not_available') {
                            item.diff_value = 1
                            item.class = 'd-none'
                        } else if (item.name == 'delivery_available_country') {
                            item.diff_value = 1
                            item.class = 'd-none'
                            // let countrySelectedAll = allCountries.map(
                            //     (country) => country.isoCode
                            // )
                            // item.initialDefault = countrySelectedAll
                        } else if (item.name === 'reason_for_price_required') {
                            item.class = 'd-none'
                        } else if (item.name == 'user_id') {
                            item.type = 'searchdrop'
                            item.style = { height: 30 }
                            item.getAllOptions = optionFunc
                            item.options = []
                            item.forcePopupIcon = false
                            item.focused = true
                        } else if (item?.name == 'auctionid') {
                            item.options = allautiondetails
                            item.isNoDefaultOptionValue = true
                            item.class =
                                all_auctions?.records?.length > 0
                                    ? 'col-sm-12 col-12'
                                    : 'd-none'
                        }

                        dynamicValueAssign.push(item)
                    }
                })

            if (dynamicValueAssign?.length > 2) {
                setFieldValue(dynamicValueAssign)
            }

            // setAnotherArray(dynamicValueAssign)
        }
    }, [project_dynamicfields, all_global_data, allautiondetails])

    const additionalFieldUpdate = (data) => {
        // setUpdatedValues(data)
    }
    const closeFunction = () => {
        history.goBack()
    }

    return (
        <>
            <ProductFieldsView
                fieldValue={fieldValue}
                userId={props.userId}
                data={data}
                showasin={false}
                homeDepot={false}
                function={props.function}
                asinMapData={[]}
                homeMapData={[]}
                initialId={inisitalValue}
                noUpdateBtn={false}
                additionalFieldUpdate={additionalFieldUpdate}
                closeFunction={closeFunction}
                customFilter={props.customFilter}
                customInitialValues={custom}
                removeUnavailableAuctionId={true}
                standalone={
                    typeof props.insidePage !== 'undefined'
                        ? props.insidePage
                        : global.standalone
                        ? global.standalone
                        : false
                }
            />
        </>
    )
}

export default DynamicListing
